import Integrations_Pipelines_AdminConfigurePipelineConnectorPage from "@Integrations/Pipelines/Pages/AdminConfigurePipelineConnectorPage.vue";
import Integrations_Pipelines_AdminConfigurePipelineDatasetPage from "@Integrations/Pipelines/Pages/AdminConfigurePipelineDatasetPage.vue";
import Integrations_Pipelines_AdminConfigurePipelineDataStreamsPage from "@Integrations/Pipelines/Pages/AdminConfigurePipelineDataStreamsPage.vue";
import Integrations_Pipelines_AdminConfigurePipelineItemFiltersPage from "@Integrations/Pipelines/Pages/AdminConfigurePipelineItemFiltersPage.vue";
import Integrations_Pipelines_AdminConfigurePipelineMappingPage from "@Integrations/Pipelines/Pages/AdminConfigurePipelineMappingPage.vue";
import Integrations_Pipelines_AdminConfigurePipelineIdsPage from "@Integrations/Pipelines/Pages/AdminConfigurePipelineIdsPage.vue";
import Integrations_Pipelines_AdminConfigurePipelinePropertiesPage from "@Integrations/Pipelines/Pages/AdminConfigurePipelinePropertiesPage.vue";
import Integrations_Pipelines_AdminCreatePipelinePage from "@Integrations/Pipelines/Pages/AdminCreatePipelinePage.vue";
import Integrations_Pipelines_AdminDashboardPage from "@Integrations/Pipelines/Pages/AdminDashboardPage.vue";
import Integrations_Pipelines_AdminManagePipelinesPage from "@Integrations/Pipelines/Pages/AdminManagePipelinesPage.vue";
import Integrations_Pipelines_AdminPipelineDetailsPage from "@Integrations/Pipelines/Pages/AdminPipelineDetailsPage.vue";
import Integrations_Pipelines_AdminPipelineDataPreviewPage from "@Integrations/Pipelines/Pages/AdminPipelineDataPreviewPage.vue";
import Integrations_Pipelines_PipelineTriggerPage from "@Integrations/Pipelines/Pages/PipelineTriggerPage.vue";

export const routes = [
  // admin pages
  {
    path: "/admin/integrations/pipelines/configure/connector/:tid/:id",
    component: Integrations_Pipelines_AdminConfigurePipelineConnectorPage
  },
  {
    path: "/admin/integrations/pipelines/configure/dataset/:tid/:id",
    component: Integrations_Pipelines_AdminConfigurePipelineDatasetPage
  },
  {
    path: "/admin/integrations/pipelines/configure/datastream/:tid/:id",
    component: Integrations_Pipelines_AdminConfigurePipelineDataStreamsPage
  },
  {
    path: "/admin/integrations/pipelines/configure/filter/:tid/:id",
    component: Integrations_Pipelines_AdminConfigurePipelineItemFiltersPage
  },
  {
    path: "/admin/integrations/pipelines/configure/mapping/:tid/:id",
    component: Integrations_Pipelines_AdminConfigurePipelineMappingPage
  },
  {
    path: "/admin/integrations/pipelines/configure/ids/:tid/:id",
    component: Integrations_Pipelines_AdminConfigurePipelineIdsPage
  },
  {
    path: "/admin/integrations/pipelines/configure/properties/:tid/:id",
    component: Integrations_Pipelines_AdminConfigurePipelinePropertiesPage
  },
  {
    path: "/admin/integrations/pipelines/create/:tid",
    component: Integrations_Pipelines_AdminCreatePipelinePage
  },
  {
    path: "/admin/integrations/pipelines/dashboard/:tid",
    component: Integrations_Pipelines_AdminDashboardPage
  },
  {
    path: "/admin/integrations/pipelines/manage/:tid",
    component: Integrations_Pipelines_AdminManagePipelinesPage
  },
  {
    path: "/admin/integrations/pipelines/details/:tid/:id",
    component: Integrations_Pipelines_AdminPipelineDetailsPage
  },
  {
    path: "/admin/integrations/pipelines/preview/:tid/:id",
    component: Integrations_Pipelines_AdminPipelineDataPreviewPage
  },
  {
    path: "/integrations/pipelines/trigger/:tid/:id",
    component: Integrations_Pipelines_PipelineTriggerPage
  }
];